'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _saveSearch = require('./remote/saveSearch');

var SaveSearch = {
    deleteSavedSearch: _saveSearch.SaveSearchRemote.deleteSavedSearch,
    fetchSavedSearches: _saveSearch.SaveSearchRemote.fetchSavedSearches,
    fetchSavedSearchItems: _saveSearch.SaveSearchRemote.fetchSavedSearchItems,
    postDeleteSavedSearches: _saveSearch.SaveSearchRemote.postDeleteSavedSearches,
    postIsSavedSearch: _saveSearch.SaveSearchRemote.postIsSavedSearch,
    postSaveSearch: _saveSearch.SaveSearchRemote.postSaveSearch,
    postSubscribeToSavedSearches: _saveSearch.SaveSearchRemote.postSubscribeToSavedSearches,
    postUnsubscribeFromSavedSearches: _saveSearch.SaveSearchRemote.postUnsubscribeFromSavedSearches
};

exports.default = SaveSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/saveSearch.js
// module id = Ykd8
// module chunks = 57